import { inject, Injectable } from '@angular/core';
import { ChatMockApi } from './apps/chat/api';
import { AuthMockApi } from './common/auth/api';
import { MessagesMockApi } from './common/messages/api';
import { NavigationMockApi } from './common/navigation/api';
import { NotificationsMockApi } from './common/notifications/api';
import { ShortcutsMockApi } from './common/shortcuts/api';
import { UserMockApi } from './common/user/api';
import { ProjectMockApi } from './dashboards/project/api';

/**
 * Mocks herdados do template Fuse, servidos pelo interceptor do `provideFuse`.
 *
 * ⚠️ Este serviço é importado EAGERLY no `app.config.ts`, então tudo que estiver aqui entra no
 * bundle INICIAL — inclusive para o hóspede que só abre o cardápio público. Em 2026-07-28 os
 * módulos de demonstração do template (mailbox, contacts, tasks, ecommerce, help-center, academy,
 * scrumboard, notes, file-manager, analytics, crypto, finance, activities, icons, search) foram removidos:
 * nenhuma rota deste app os alcançava e nenhum código os consumia.
 *
 * **Antes de adicionar um mock aqui, confirme que existe consumidor real** — o custo é cobrado no
 * carregamento de todo mundo. Os que sobraram têm consumidor identificado:
 *
 * | Mock | Quem consome |
 * |---|---|
 * | `navigation`, `notifications` | `initialDataResolver` |
 * | `messages`, `shortcuts`, `user` | componentes do shell do Fuse (`layout/common/*`) |
 * | `auth` | fluxo de autenticação herdado |
 * | `apps/chat` | `quick-chat.service`, renderizado pelo layout `classic` (o default) |
 * | `dashboards/project` | `TableService`, usado pelo `TableTreeComponent` em product-group-list |
 */
@Injectable({ providedIn: 'root' })
export class MockApiService {
    authMockApi = inject(AuthMockApi);
    chatMockApi = inject(ChatMockApi);
    messagesMockApi = inject(MessagesMockApi);
    navigationMockApi = inject(NavigationMockApi);
    notificationsMockApi = inject(NotificationsMockApi);
    projectMockApi = inject(ProjectMockApi);
    shortcutsMockApi = inject(ShortcutsMockApi);
    userMockApi = inject(UserMockApi);
}
